
<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 receiver-section">
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">
      <div class="form-group">
        <label class="domp-form-label-review ebook-label" translate="ebook.fullName">Name</label>
        <label class="domp-form-label-resume ebook-review">{{newEBook.insertedPaymentObject.createdBy}}</label>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">
      <label class="domp-form-label-review ebook-label" translate="ebook.eSavingsBookName"></label>
      <label class="domp-form-label-resume ebook-review">{{newEBook.tempObj.nameInput}}</label>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-5">
        <div class="form-group m-t-15 m-b-0">
        <label class="domp-form-label-review ebook-label" translate="ebook.mainAccount"></label>
        <label class="domp-form-label-resume" style="font-weight:300;font-size:18px;color:#ff4d5a;">{{newEBook.tempObj.fromAccountSelect.friendlyName}}</label>
        <label class="domp-form-label-accnumber ebook-review" >{{newEBook.insertedPaymentObject.mainAccountNumber}}</label>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-7 p-l-0">
      <div class="m-t-15 m-b-0">
        <label class="domp-form-label-review ebook-label" translate="ebook.dateOfCreation"></label>
        <label class="domp-form-label-resume ebook-review">{{newEBook.insertedPaymentObject.dateOfCreation | date:'shortDate'}}</label>
      </div>
    </div>
  </div>
  
</div>

  <!-- SMS auth old -->
<!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 purpose-section">
  <div class="row">
    <div class="col-sm-6 col-xs-12" ng-if="domesticPaymentCro.smsAuthentificate != true">
      <div class="form-group">
        <label class="exchange-resume-label" translate="currencyConversion.smsAuthentification"></label>
        <button class="btn btn-default confirm-btn d-block" translate="currencyConversion.sendSms" data-ng-click="domesticPaymentCro.showSMSAuthentification();"></button>
      </div>
    </div>
    <div class="col-sm-6 col-xs-12" ng-if="domesticPaymentCro.smsAuthentificate == true">
      <div class="form-group">
        <div class="input-group">
          <input type="text" class="form-control input-field" data-ng-model="domesticPaymentCro.smsPasswordInput" placeholder="{{'currencyConversion.smsPassword' | translate}}">
          <span class="input-group-btn">
            <button class="btn btn-default input-group-app-btn domp-btn-height">
              <i class="zmdi zmdi-lock"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>-->

<div class="domp-footer-wrapper">
  <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
    <button class="col-lg-2 col-md-2 col-sm-2 col-xs-3 m-r-10 btn btn-primary-warning " translate="ebook.delete" ng-click="newEBook.deletePayment();">Delete</button>

    <button class="col-lg-2 col-md-2 col-sm-2 col-xs-3 btn btn-primary " translate="ebook.edit" ng-click="newEBook.editPayment();">Edit</button>

    <!--<button class="col-lg-4 col-md-4 col-sm-4 col-xs-4 btn btn-primary app-btn-blue domp-sign-btn pull-right" ng-click="domesticPaymentSrb.signPayment();" ng-disabled="!domesticPaymentSrb.$dirty && domesticPaymentSrb.smsAuthentificate == false">Sign</button>-->
      <button class="col-lg-2 col-md-2 col-sm-2 col-xs-3  m-r-10 btn btn-default pull-right" translate="ebook.confirm" ng-click="newEBook.sign()">Sign</button>

  </div>
</div>
